const initialState = {
    items: null,
    tmpItems: null,
    tmpKeyIndex: {}
}

export default function QuestionReducer(state = initialState, action) {
    switch (action.type) {
        case "UPDATE_ITEM":
            console.log(action.data);
            if (null != action.data.items.length) {
                let pid = action.data.pid;
                let tmp = [...action.data.items];
                action.data.items.forEach(function (value, index) {
                    if (!tmp[index]) tmp[index] = {}
                    tmp[index].id = "item-" + index
                    if (!tmp[index].cf) tmp[index].cf = {}
                });
                // console.log(tmp);
                return {
                    pid: pid,
                    items: action.data.items,
                    tmpItems: tmp
                };
            }
            if (null != action.data.items.msg) {
                alert(action.data.items.msg);
            }
            return state;
        case "UPDATE_TMP_ITEM":
            // console.log(action.data);
            try {
                return {
                    ...state,
                    items: state.items,
                    tmpItems: action.data
                };
            } catch (e) {
                console.error(action);
                return state
            }
        case "ON_ADD_TMP_OPTION":
            try {
                // console.log(action.index);
                let tmp = [...state.tmpItems];
                tmp[action.index].op.push({ na: "", o_type: 0 });
                // let tmp = {};
                // action.data.forEach(function (value, index) {
                //     tmp[value.id] = index
                // });
                return {
                    ...state,
                    items: state.items,
                    tmpItems: tmp
                };
            } catch (e) {
                return state;
            }
        case "QUESTION_SET_RANDOM":
            try {
                let tmp = [...state.tmpItems];
                tmp[action.index].cf.parameters.random = action.data;
                console.log(action, tmp);
                return {
                    ...state,
                    items: state.items,
                    tmpItems: tmp
                };
            } catch (e) {
                return state;
            }
        case "QUESTION_SET_LAYOUT":
            try {
                let tmp = [...state.tmpItems];
                tmp[action.index].cf.parameters.layout = action.data;
                // console.log(action, tmp);
                return {
                    ...state,
                    items: state.items,
                    tmpItems: tmp
                };
            } catch (e) {
                return state;
            }
        case "QUESTION_SET_MA":
            try {
                let tmp = [...state.tmpItems];
                tmp[action.index].ma[action.key] = action.data;
                // console.log(action, tmp);
                return {
                    ...state,
                    items: state.items,
                    tmpItems: tmp
                };
            } catch (e) {
                return state;
            }
        case "QUESTION_SET_BONUS":
            try {
                let tmp = [...state.tmpItems];
                tmp[action.index].cf.parameters.bonus = action.data;
                // console.log(action, tmp);
                return {
                    ...state,
                    items: state.items,
                    tmpItems: tmp
                };
            } catch (e) {
                return state;
            }
        case "QUESTION_SET_LIMIT":
            try {
                let tmp = [...state.tmpItems];
                tmp[action.index].cf.parameters.limit = action.data;
                console.log(action, tmp);
                return {
                    ...state,
                    items: state.items,
                    tmpItems: tmp
                };
            } catch (e) {
                return state;
            }
        case "QUESTION_SET_OPEN_LIMIT":
            try {
                let tmp = [...state.tmpItems];
                tmp[action.index].op.forEach((val, index) => {
                    tmp[action.index].op[index].limit = action.data;
                })
                console.log(action, tmp);
                return {
                    ...state,
                    items: state.items,
                    tmpItems: tmp
                };
            } catch (e) {
                return state;
            }
        case "QUESTION_SET_GROUP":
            try {
                let tmp = [...state.tmpItems];
                tmp[action.index].cf.parameters.group = action.data;
                console.log(action, tmp);
                return {
                    ...state,
                    items: state.items,
                    tmpItems: tmp
                };
            } catch (e) {
                return state;
            }
        case "QUESTION_SET_ARRAY":
            try {
                let tmp = [...state.tmpItems];
                tmp[action.index].cf.parameters.row_op = action.data;
                console.log(action, tmp);
                return {
                    ...state,
                    items: state.items,
                    tmpItems: tmp
                };
            } catch (e) {
                return state;
            }
        default:
            return state;
    }
}